// @ts-check
// Allowlist de protocolos (03-frontend §8.6, §10.3). Nunca construir una URL
// insertando strings directamente; usar siempre `URL`/`URLSearchParams`.

const ALLOWED_PROTOCOLS = new Set(['https:', 'http:']);

/**
 * Valida que una URL (absoluta o relativa) usa un protocolo permitido.
 * Rechaza `javascript:`, `data:`, `vbscript:` y cualquier otro no explícito.
 * @param {string} rawUrl
 * @param {string} [base] - Base para resolver URLs relativas (por defecto, origin actual).
 * @returns {URL|null} La URL parseada si es segura, o null si debe rechazarse.
 */
export function parseSafeUrl(rawUrl, base = globalThis.location?.origin ?? 'http://localhost') {
  let url;
  try {
    url = new URL(rawUrl, base);
  } catch {
    return null;
  }
  if (!ALLOWED_PROTOCOLS.has(url.protocol)) {
    return null;
  }
  return url;
}

/**
 * Comprueba si una ruta de destino es interna (mismo origin) antes de navegar/redirigir.
 * Usar siempre antes de asignar a `location.href` o `next`/`returnUrl` (§8.6).
 * @param {string} rawUrl
 * @param {string} [allowedOrigin]
 * @returns {boolean}
 */
export function isSafeInternalUrl(rawUrl, allowedOrigin = globalThis.location?.origin) {
  const url = parseSafeUrl(rawUrl, allowedOrigin);
  if (!url || !allowedOrigin) return false;
  return url.origin === allowedOrigin;
}
